export enum STAGE {
  FACE_DISPLACED = "face_displaced",
  FACE_PITCH_ANGLE_DEVIATION = "face_pitch_angle_deviation",
  FACE_ROLL_ANGLE_DEVIATION = "face_roll_angle_deviation",
  FACE_YAW_ANGLE_DEVIATION = "face_yaw_angle_deviation",
  FACE_DISTANCE_CLOSE = "face_distance_close",
  FACE_DISTANCE_FAR = "face_distance_far",
  LIGHTING_INSUFFICIENT = "lighting_insufficient",
  LIGHTING_EXCESSIVE = "lighting_excessive",
  LIGHTING_ANGLE_DEVIATION = "lighting_angle_deviation",
  CAPTURING = "capturing",
}

export enum PROBLEM {
  FACE_DISPLACED = "face_displaced",
  FACE_PITCH_ANGLE_DEVIATION = "face_pitch_angle_deviation",
  FACE_ROLL_ANGLE_DEVIATION = "face_roll_angle_deviation",
  FACE_YAW_ANGLE_DEVIATION = "face_yaw_angle_deviation",
  LIGHTING_INSUFFICIENT = "lighting_insufficient",
  LIGHTING_EXCESSIVE = "lighting_excessive",
  LIGHTING_ANGLE_DEVIATION = "lighting_angle_deviation",
  QUALITY_NOISE = "quality_noise",
  QUALITY_BLUR = "quality_blur",
  QUALITY_RESOLUTION = "quality_resolution",
  QUALITY_FULL_FACE = "quality_full_face",
  LOW_IMAGE_QUALITY = "low_image_quality",
}

// TODO: implement and use the lodash's `pick` function
const { CAPTURING, ...QUALITY_PROBLEM_STAGE } = STAGE

export const Stages = [...Object.values(QUALITY_PROBLEM_STAGE), CAPTURING]

// TODO: Move common stages to a shared module
export const ANGLE_DEVIATION_STAGES = [
  STAGE.FACE_ROLL_ANGLE_DEVIATION,
  STAGE.FACE_YAW_ANGLE_DEVIATION,
  STAGE.FACE_PITCH_ANGLE_DEVIATION,
] as const
